import React from 'react';
import TabList from './TabList';
import { Routes } from './Routes';
import { BrowserRouter, Switch } from 'react-router-dom';
import './Tabs.scss';

type TabsType = {
  id: number;
  name: string;
  component: React.FC;
};
interface Tabs2Props {
  data: TabsType[];
}

export const Tabs: React.FC<Tabs2Props> = ({ data, ...props }) => {
  return (
    <BrowserRouter>
      <TabList data={data} {...props} />
      <Switch>
        <Routes data={data} />
      </Switch>
    </BrowserRouter>
  );
};
